import React from 'react'
import toJS from '../hoc/toJS.jsx'
import { connect } from 'react-redux'
import { compose } from 'redux'
import getData from '../functions/getData'
import { PROGRAM_MOVIES_ITEMS, TRANSLATION } from '../constants/state'
import SecondaryFilter from '../Overview/OverviewFilter/SecondaryFilter'
import TranslationCont from '../General/TranslationCont.jsx'

const mapStateToProps = (state, ownProps) => ({
    translation: getData(state, TRANSLATION),
    movies: getData(state, PROGRAM_MOVIES_ITEMS),
})

const SecondaryFilterAccess = ({
    filters,
    movies,
    filterStrings,
    allItems,
    queryStringValues,
    cinemaFrontPkType,
    translation

}) => (
    <div className="access-filter access-filter-sec">
        <nav aria-labelledby="filter-2">
            <h3 id ="filter-2" className="access-filter-title access-typo">
                <TranslationCont id="moreFilters" uppercase={true}>Weitere Filter</TranslationCont>
            </h3>

            <SecondaryFilter
                filters={filters}
                movies={movies}
                filterStrings={filterStrings}
                allItems={allItems}
                queryStringValues={queryStringValues}
                cinemaFrontPkType={cinemaFrontPkType}
                translation={translation}
            />
        </nav>
    </div>
)


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(SecondaryFilterAccess)